module.exports = __webpack_public_path__ + "static/media/lv.56acb99b.svg";